const V2Day1Part5StartingDialog = {
    startDialogId: 'part5_op1',
    nodes: {
        part5_op1: {
            id: 'part5_op1',
            speaker: 'Romo Darius',
            text: `Terima kasih atas bantuan warga desa`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'part5_op2',
        },
        part5_op2: {
            id: 'part5_op2',
            speaker: 'Romo Darius',
            text: `Mayat Sondakh sudah kita pindahkan ke dalam gereja.`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'part5_op3',
        },
        part5_op3: {
            id: 'part5_op2',
            speaker: 'Romo Darius',
            text: `Mohon semua bantu doa untuk kedamaian Sondakh dan yang ditinggalkan.`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'part5_op4',
        },
        part5_op4: {
            id: 'part5_op2',
            speaker: 'Romo Darius',
            text: `Amin`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'part5_op5',
        },
        part5_op5: {
            id: 'part5_op2',
            speaker: 'Diana',
            text: `Aku masih syok dan tidak percaya....`,
            characterImage: '/assets/character/v2/diana.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'part5_op6',
        },
        part5_op6: {
            id: 'part5_op2',
            speaker: 'Diana',
            text: `Memang kita tidak terlalu akrab dengan Sondakh dan ibu Holga memang....`,
            characterImage: '/assets/character/v2/diana.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'part5_op7',
        },
        part5_op7: {
            id: 'part5_op2',
            speaker: 'Diana',
            text: `Memang kita tidak terlalu akrab dengan Sondakh dan ibu Holga memang....`,
            characterImage: '/assets/character/v2/diana.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            choices: [
                {
                    text: 'Sedikit menyebalkan',
                    nextDialogId: 'part5_op8',
                    //Add hostility
                },
                {
                    text: 'Menyalahkan kita?',
                    nextDialogId: 'part5_op8',
                },
            ],
        },
        part5_op8: {
            id: 'part5_op2',
            speaker: 'Elsa',
            text: `Betul sekali... aku sangat sedih`,
            characterImage: '/assets/character/v2/elsa.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'part5_op9',
        },
        part5_op9: {
            id: 'part5_op2',
            speaker: 'Elsa',
            text: `Tapi warga desa seperti Pak Ato dan Bu Holga, kenapa mereka langsung menyalahkan aku` ,
            characterImage: '/assets/character/v2/elsa.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'part5_op10',
        },
        part5_op10: {
            id: 'part5_op2',
            speaker: 'Diana',
            text: `Walaupun kita pertama kali disana... bukan berarti kita yang bertanggung jawab...` ,
            characterImage: '/assets/character/v2/diana.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'part5_op11',
        },
        part5_op11: {
            id: 'part5_op2',
            speaker: 'Diana',
            text: `Kak Yan, apa bisa bantu bicara ke orang-orang desa` ,
            characterImage: '/assets/character/v2/diana.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            choices: [
                {
                    text: 'Tidak ada salahnya mencoba',
                    nextDialogId: 'part5_op8',
                    isEnd : true
                    //Add hostility
                },
                {
                    text: 'Pasti, coba aku bicarakan dengan mereka.',
                    nextDialogId: 'part5_op8',
                    isEnd : true
                },
            ],
        },
    },
}

export default V2Day1Part5StartingDialog